// hooks/useSingleTab.js
import { PATH } from 'constants/path';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useSingleTab = (path, lockKey) => {
    const location = useLocation();
    const TAB_ID = Math.random().toString(36).substr(2, 9);
    const STORAGE_KEY = lockKey ? `singleTabLock_${lockKey}` : `singleTabLock_${path.replace(/\//g, '_')}`;

    useEffect(() => {
        const isTargetPage = location.pathname.startsWith(path);

        if (!isTargetPage) return;

        localStorage.setItem(STORAGE_KEY, TAB_ID);

        const handleStorageChange = (event) => {
            if (event.key === STORAGE_KEY && event.newValue !== TAB_ID) {
                window.location.href = PATH.ELEARNING.STUDENT.ROOT;
            }
        };

        window.addEventListener('storage', handleStorageChange);

        const handleUnload = () => {
            if (localStorage.getItem(STORAGE_KEY) === TAB_ID) {
                localStorage.removeItem(STORAGE_KEY);
            }
        };

        window.addEventListener('beforeunload', handleUnload);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, [location.pathname]);
};

export default useSingleTab;
